module.exports = __webpack_public_path__ + "static/todos-preview.700d6eb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/todos-preview.png
// module id = ./src/assets/graphics/todos-preview.png
// module chunks = 1